import {connect} from 'react-redux';

import {ViewerPanelId} from '../../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {Dispatch} from '../../../../../../store/appStore';
import {focusViewerComposerAsyncAction} from '../../../../../../store/panels/viewer/viewerPanelActions';
import {EditHereMessageBanner} from './editHereMessageBanner';

/*
 * Props.
 */

interface EditHereMessageBannerContainerProps {
  panelId: ViewerPanelId;
  messageUid: string;
}

/*
 * Redux.
 */

function mapDispatchToProps(dispatch: Dispatch, props: EditHereMessageBannerContainerProps) {
  return {
    onEditHereClick: () => dispatch(focusViewerComposerAsyncAction(props.panelId, props.messageUid)),
  };
}

export const EditHereMessageBannerContainer = connect(null, mapDispatchToProps)(EditHereMessageBanner);
